import _memoize from 'lodash/memoize';
import moment from 'moment';

export const findInfluencerByVideo = _memoize(
  (video, campaignInfluencers) => {
    const influencer = campaignInfluencers?.find(({ id }) =>
      video?.campaign_influencer_ids?.includes(id)
    );

    if (!influencer) {
      console.log({ video, campaignInfluencers });
    }

    return influencer || {};
  },
  (video) => video.id
);

export const findInfluencerById = _memoize(
  (id, campaignInfluencers) =>
    campaignInfluencers?.find((influencer) => influencer.id === id) || {}
);

export const findVideoById = _memoize(
  (id, videos) => videos.find((videos) => videos.id === id) || {}
);

export const findImageById = _memoize(
  (id, imagePosts) => imagePosts.find((image) => image.id === id) || {}
);

export const getVideoDuration = ({ video_segments, duration }) => {
  if (video_segments && video_segments.length > 0) {
    const [{ start_at, end_at }] = video_segments;

    return end_at - start_at;
  }

  return duration;
};

export const segmentNotEqualToVideo = (video, { start_at, end_at }) =>
  start_at !== 0 || end_at !== video.duration;

export const videoHasSegments = ({ video_segments, ...video }) => {
  return (
    video_segments &&
    video_segments.length > 0 &&
    segmentNotEqualToVideo(video, video_segments[0])
  );
};

export const getTrackedPlatforms = (campaignInfluencers) => {
  const twitch = campaignInfluencers.some(
    (influencer) => !!influencer.twitch_url
  );
  const youtube = campaignInfluencers.some(
    (influencer) => !!influencer.youtube_url
  );

  const twitter = campaignInfluencers.some(
    (influencer) => !!influencer.twitter_url
  );
  const instagram = campaignInfluencers.some(
    (influencer) => !!influencer.instagram_url
  );
  const tiktok = campaignInfluencers.some(
    (influencer) => !!influencer.tiktok_url
  );
  const facebook = campaignInfluencers.some(
    (influencer) => !!influencer.facebook_url
  );
  const facebookGaming = campaignInfluencers.some(
    (influencer) => !!influencer.facebook_gaming_url
  );

  return {
    twitch,
    youtube,
    twitter,
    instagram,
    tiktok,
    facebook,
    facebookGaming,
  };
};

// segment_start is in epoch time (milliseconds)
export const getMomentURL = (video, segment_start) => {
  if (!video || !video.link) {
    return null;
  }

  let momentURL = video.link;

  if (video.resource === 'facebook_gaming' || video.resource === 'facebook') {
    momentURL = momentURL + `?t=${segment_start / 1000}`;
  } else {
    const momentSS = moment.utc(segment_start);

    momentURL += `${momentURL.includes('?') ? '&' : '?'}t=${momentSS.format(
      'HH'
    )}h${momentSS.format('mm')}m${momentSS.format('ss')}s`;
    // https://www.twitch.tv/videos/603719988?t=0h33m52s
  }

  return momentURL;
};

export const streamingPlatforms = [
  'twitch',
  'youtube',
  'facebook_gaming',
  'facebook',
];

export const videoIsFromStreamingPlatform = (video) => {
  return streamingPlatforms.includes(video.resource);
};
